import { faGlobe } from "@fortawesome/pro-solid-svg-icons/faGlobe";
import { faUserLock } from "@fortawesome/pro-solid-svg-icons/faUserLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    isPublic: boolean;
}

const ListIcon: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { isPublic } = props;

    return (
        <MuiMuted>
            <span title={isPublic ? t("Common.Feed.List.PublicList") : t("Common.Feed.List.PrivateList")}>
                &nbsp;<FontAwesomeIcon fixedWidth icon={isPublic ? faGlobe : faUserLock} />
            </span>
        </MuiMuted>
    );
};

export default ListIcon;
